import styled from 'styled-components';

import { device } from '../../styles/breakpoints';

const Wrapper = styled.div`
  overflow-x: hidden;
  display: flex;
  justify-content: center;
  margin: 200px auto 0px;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.grayPallet16};
  padding: 0 20px 100px;
  max-width: 96vw;

  @media ${device.largeLaptop} {
    max-width: 1370px;
  }

  .main-aba-property {
    display: flex;
    padding-bottom: 30px;

    .aba-line {
      width: 100%;
      border-bottom: 1px solid ${({ theme }) => theme.colors.grayPallet17};
    }
  }
`;

const Header = styled.h2`
  text-align: center;
  margin-bottom: 50px;
  font-size: 54px;
  color: ${({ theme }) => theme.colors.blackPallet2};

  span {
    background-size: 100% 100%;
    background-position: 0 0;
    background-image: url('/static/images/line.png');
  }
`;

const Subtitle = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  padding-bottom: 10px;
  line-height: 1.25;
`;

const Text = styled.div`
  line-height: 1.25;

  span {
    font-weight: ${({ theme }) => theme.typography.fontWeights.bold};
  }

  &.bottomText {
    padding: 30px 0;
  }
`;

const Table = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableRow = styled.div`
  border: 2px solid ${({ theme }) => theme.colors.black};
  border-bottom: none;
  display: flex;

  &:first-child {
    border: none;

    .rightCell {
      border: none;
    }
  }

  &:last-child,
  &.borderBottom {
    border-bottom: 2px solid ${({ theme }) => theme.colors.black};
  }

  .rightCell {
    color: ${({ theme }) => theme.colors.greenPallet4};
    border-left: 2px solid ${({ theme }) => theme.colors.black};
    padding: 8px 10px;
    width: 60%;
  }

  .aba-table-col-title {
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    padding: 15px 20px 0px;
    color: ${({ theme }) => theme.colors.bluePallet10};
  }
`;

const TableCol = styled.div`
  font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
  width: 40%;
  padding: 8px 20px;
  color: ${({ theme }) => theme.colors.bluePallet10};

  .notice {
    color: ${({ theme }) => theme.colors.grayPallet16};
    font-weight: ${({ theme }) => theme.typography.fontWeights.regular};
  }
`;

const Insurance = styled.div`
  .aba-insurance-title {
    font-weight: ${({ theme }) => theme.typography.fontWeights.medium};
    text-align: center;
    padding-top: 30px;
    padding-bottom: 10px;
    color: ${({ theme }) => theme.colors.bluePallet10};
  }

  .aba-insurance-text {
    border: 2px solid ${({ theme }) => theme.colors.black};
    padding: 8px 20px;
  }
`;

const SellerBuyer = styled.div`
  display: flex;

  @media ${device.smallLaptop} {
    flex-direction: column;
  }

  .main-aba-seller-buyer-leftCol {
    width: 50%;

    @media ${device.smallLaptop} {
      width: 50%;
    }
  }

  .main-aba-seller-buyer-col {
    width: 50%;
    display: flex;
    padding-top: 20px;

    &-subcol {
      display: flex;
    }
  }

  .aba-line-person,
  .aba-line-date {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grayPallet17};
  }

  .aba-line-person {
    margin-right: 5px;
    width: 200px;

    @media ${device.smallLaptop} {
      width: 160px;
    }
  }

  .aba-line-date {
    width: 150px;

    @media ${device.smallLaptop} {
      width: 80px;
    }
  }
`;

export default {
  Wrapper,
  Header,
  Subtitle,
  Text,
  Table,
  TableRow,
  TableCol,
  Insurance,
  SellerBuyer,
};
